angular.module('cfn').service('BookinIsoXmlHttp', BookinIsoXmlHttp);

BookinIsoXmlHttp.$inject = ['$http'];
function BookinIsoXmlHttp($http) {
  var baseUrl = '/365FarmNet/rest/booking/isoxml';

  this.allDataSets = function() {
    return $http.get(baseUrl + '/dataSets').then(function(result) {
      return result.data;
    });
  };

  this.importDataSet = function(dataSetUuid) {
    return $http
      .post(baseUrl + '/importDataSet', '"' + dataSetUuid + '"')
      .then(function(result) {
        return result.data;
      });
  };
}
